import { Injectable } from '@angular/core';
import { PostmethodService } from '../app-config/postmethod.service';
import { environment } from '../../environments/environment';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class SharedService {

	constructor(private ws: PostmethodService, private http: HttpClient) { }


	// createMaster(request: any) {
	//   return this.ws.wsPost(request, environment.masterUrl + "getCityMaster");
	// }

	allowNumbersOnly(event: any) {
		var inp = String.fromCharCode(event.keyCode);
		if (/[0-9]/.test(inp)) {
			return true;
		} else {
			event.preventDefault();
			return false;
		}
	}

	allowAlphabetsOnly(event: any) {
		var inp = String.fromCharCode(event.keyCode);
		if (/[a-zA-Z\s]/.test(inp)) {
			return true;
		} else {
			event.preventDefault();
			return false;
		}
	}

	private secretKey = 'A01234567890Z';

	encryptData(data: string): string {
		return CryptoJS.AES.encrypt(data, this.secretKey).toString();
	}

	decryptData(encryptedData: string): string {
		const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
		return bytes.toString(CryptoJS.enc.Utf8);
	}

	setSessionStorage(key: string, value: string): void {
		const encryptedValue = this.encryptData(value);
		sessionStorage.setItem(key, encryptedValue);
	}

	getSessionStorage(key: string): string | null {
		const encryptedValue = sessionStorage.getItem(key);
		return encryptedValue ? this.decryptData(encryptedValue) : null;
	}

	uploadFile(file: File): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('file', file, file.name);
		return this.http.post(`${environment.baseUrl}/upload`, formData);
	  }

}